import { useCallback } from 'react';
import { generateAdminDashboardUrl } from '../../hooks';
import { routes } from '../../routes';
import type { AdminExtractedEntityType } from '../AdminConsoleButton';

export const useGetPathToAdminEntitiesList = () =>
  useCallback((entityType: AdminExtractedEntityType) => {
    switch (entityType) {
      case 'community':
        return generateAdminDashboardUrl(routes.community.list);
      case 'giving':
        return generateAdminDashboardUrl(routes.giving.list);
      case 'organization':
        return generateAdminDashboardUrl(routes.organization.list);
      case 'program':
        return generateAdminDashboardUrl(routes.program.list);
    }
  }, []);
